import { useCallback, useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { RecordBooks } from "../types";
import { Line } from "react-chartjs-2";
import { ChartData } from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

var month = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      title: {
        display: false,
      },
      ticks: {
        stepSize: 10, // Set step size to 10
      },
    },
    x: {
      title: {
        display: false,
      },
    },
  },
};

const formatDate = (d: Date) => {
  const m = month[d.getMonth()];
  return ` ${d.getDate()} ${m}`;
};
function generateDatesMap() {
  var datesMap = new Map<string, number>();
  var today = new Date(); // Current date
  var weekBefore = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000); // One week before

  var currentDate = weekBefore;
  while (currentDate <= today) {
    const dd = formatDate(currentDate);
    datesMap.set(dd, 0); // Set date as key and 0 as value
    currentDate.setDate(currentDate.getDate() + 1); // Increment current date by 1 day
  }

  return datesMap;
}
export const LineChart = ({ books }: { books: RecordBooks }) => {
  const [data, setData] = useState<ChartData<"line"> | undefined>();

  const extractSessionData = useCallback((records: RecordBooks) => {
    const dateMap = generateDatesMap();

    const currentDate: Date = new Date();
    const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
    for (const bookId in records) {
      const book = records[bookId];
      // Iterate through the reading sessions in reverse order
      for (let i = book.readingSessions.length - 1; i >= 0; i--) {
        const session = book.readingSessions[i];
        const sessionDate = new Date(session.date);

        // Calculate the difference in days between the current date and session date
        const diffDays = Math.round(
          Math.abs((currentDate.getTime() - sessionDate.getTime()) / oneDay)
        );

        // Break the loop if more than 7 days have been processed
        if (diffDays > 7) {
          break;
        }

        const formattedDate = formatDate(sessionDate);
        if (!formattedDate) {
          continue;
        }

        // Calculate the number of sessions on this day and accumulate the total
        const sessionCount = session.page_finish - session.page_start;
        if (dateMap.has(formattedDate)) {
          //@ts-ignore
          dateMap.set(formattedDate, dateMap.get(formattedDate) + sessionCount);
        }
      }
    }

    const labels: string[] = [];
    const data: number[] = [];

    for (const [date, totalSessions] of dateMap.entries()) {
      labels.unshift(date);
      data.unshift(totalSessions);
    }
    return { labels: labels.reverse(), data: data.reverse() };
  }, []);
  useEffect(() => {
    const sessionData = extractSessionData(books);
    const newData = {
      labels: sessionData.labels,
      datasets: [
        {
          label: "",
          data: sessionData.data,
          fill: false,
          borderColor: "#ea8b8b",
          tension: 0.1,
        },
      ],
    };
    setData(newData);
  }, [books, extractSessionData]);

  return data ? (
    <div style={{ height: "100px", width: "100%" }}>
      <Line options={options} data={data} />
    </div>
  ) : null;
};
